<template>
  <MainLayout>
    <v-card class="ma-5">
      <v-card-title>
        <v-icon>mdi-view-list</v-icon>
        Graffiti Überblick
        <QuickAddModal class="ml-auto"></QuickAddModal>
      </v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                ID
              </th>
              <th class="text-left">
                Kommentar
              </th>
              <th class="text-left">
                Original
              </th>
              <th class="text-left">
                Graffiti erkannt
              </th>
              <th class="text-left">
                in Bearbeitung
              </th>
              <th class="text-left">
                Analysiert
              </th>
              <th class="text-left">
                Vorschau
              </th>
            </tr>
            </thead>
            <tbody>
            <template v-for="quick of quicks">
              <QuickRow :quick="quick" :key="quick.id"></QuickRow>
            </template>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </MainLayout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MainLayout from '../../components/Layouts/MainLayout.vue';
import QuickAddModal from '../../components/QuickAddModal.vue';

export default {
  name: 'QuicksPage',
  components: {
    MainLayout,
    QuickAddModal,
    QuickRow: () => import('../../components/QuickRow.vue'),
  },

  computed: {
    ...mapState('resources', ['quicks']),
  },

  created() {
    this.getQuicksFromApi();
  },

  methods: {
    ...mapActions('resources', ['getQuicksFromApi']),
  },
};
</script>

<style lang="scss" scoped>

</style>
